export enum CasesSubMenuEnum {
    FINANCEIRO = '1',
    SAO_CRISTOVAO = '2',
    GENERALI = '3',
    MERCADO_GRAFICO = '4',
    SEGUROS = '5'
}
